// @flow
import * as React from 'react';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import { IntlContext, useIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import type { RouterHistory, Match } from 'react-router-dom';
import { numberPointsCallbacksCable } from 'esm-web-pro/containers/pages/network/objects/cable/MapCable';
import UseHighlightCable from 'esm-web-pro/containers/pages/network/objects/cable/useHighlightCable';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import { Text } from 'grommet';
import cableAndFiberMessages from 'esm-web-pro/messages/cableAndFiberMessages';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';
import { POINT12_CONTENT_TOOLTIP_KEY } from './CableList/Point12CableList';


type CableTitleProps = {
    cable: Object,
    editor: BaseEditor,
    setClickedRowIdentity: (rowId: string) => void,
    clickedRowIdentity?: string,
    history: RouterHistory,
    match: Match,
    rowId: string,
}


const CableTitle = (props: CableTitleProps) => {
    const intl: IntlContext = useIntl();
    const {
        cable, editor, setClickedRowIdentity, clickedRowIdentity, history, match, rowId,
    } = props;

    const highlightCable = () => {
        setClickedRowIdentity(rowId);
        editor.unregisterAllLoadingCallback();
        editor.registerMultipleLoadingCallbacks(numberPointsCallbacksCable(cable));
        editor.registerLoadingCallback(UseHighlightCable(cable.path.map((c) => [c[1], c[0]])));
        editor.reloadFeatures();
    };

    const actions = [{
        key: cable.uuid,
        icon: <MeatballsIcon />,
        size: '20px',
        width: '3px',
        callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            e.stopPropagation();
            const path = match.url.split('/layer');
            history.push(`${path[0]}/layer/cable/${cable.identity}`);
        },
        tooltip: intl.formatMessage(actionMessages.more),
        tooltipKey: POINT12_CONTENT_TOOLTIP_KEY,
    }];

    return (
        <ContentRow
            onClick={highlightCable}
            actions={(
                <RowActions
                    gapBetweenActions="small"
                    actions={actions}
                />
            )}
            rowId={rowId}
            clickedRowIdentity={clickedRowIdentity}
            padLevel={1}
        >
            <ValueText>
                {`${intl.formatMessage(cable.patch ? cableAndFiberMessages.patchCableLong
                    : cableAndFiberMessages.cableLong)} ${cable.sequence} (${cable.fiber_count}, 
                ${cable.patch ? cable.length : cable.reserve || '0'} m)`}
            </ValueText>
        </ContentRow>
    );
};

CableTitle.defaultProps = {
    clickedRowIdentity: undefined,
};

export default withRouter(CableTitle);
